/* eslint-disable no-underscore-dangle */

// track downloads
const $downloadLinks = document.querySelectorAll('a[href*="download?file="],a[href*="part-support-files/"],a[href$=".pdf"],a[href$=".PDF"]');

$downloadLinks.forEach(($anchor) => {
    // set up defaults for category, action, label
    const action = 'Download';
    const label = $anchor.href;
    let category = 'File';

    // override category for datasheets and databriefs
    if (label.match(/\/Datasheets\//)) { // is this a datasheet?
        category = 'Datasheet';
    } else if (label.match(/\/Databriefs\//)) { // is this a datbrief
        category = 'Databrief';
    } else if (label.match(/\/IBIS-Files\//)) { // is this a IBIS-File
        category = 'IBIS-File';
    } else if (label.match(/\/BSDL-Files\//)) { // is this a BSDL-File
        category = 'BSDL-File';
    } else if (label.match(/\/Die-Files\//)) { // is this a Die-File
        category = 'Die-File';
    } else if (label.match(/\/PCN-Files\//)) { // is this a PCN-File
        category = 'PCN-File';
    } else if (label.match(/\/App-Note-Files\//)) { // is this an App-Note-File
        category = 'App-Note-File';
    } else if (label.match(/\/part-support-files\//)) { // is this a Part-Support-File
        category = 'Part-Support-File';
    } else if (label.match(/\/download\?file=/)) { // is this a Share-Point-File
        category = 'Share-Point-File';
    } else if (label.match(/\.pdf/i)) { // is this a PDF file
        category = 'PDF';
    }

    // add the tracker for the event
    $anchor.addEventListener('click', () => {
        if (typeof window.ga === 'function') {
            window.ga('send', 'event', {
                eventCategory: category,
                eventAction: action,
                eventLabel: label,
            });
        } else if (typeof window._gaq === 'object') {
            window._gaq.push(['_trackEvent', category, action, label]);
        }
    });
});
